<template>
    
    <Link 
        :tag="tag"
        :class="css"
        :url="url"
        ref="item">

        <slot></slot>

    </Link>

</template>

<script>
import Link from '@/components/link/Link.vue'

export default {

    props: {
        data: Object
    },
    
    computed: {

        css: function () {

            let css = 'list-item list-item--inline'
            if ( this.data.articleSlug ) {
                css += ' clickable'
            }

            return css
        },

        tag: function() {
            return ( this.url == null ) ? 'div' : 'a'
        },

        url: function() {
            return ( ( this.data.articleSlug ) ? '/product/' + this.data.articleSlug : null )
        }
    },

    components: {
        Link
    }
}
</script>

<style scoped>

</style>